/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-box-flex:1;flex:1}[_nghost-%COMP%]   .private-classes-page[_ngcontent-%COMP%]{height:100%}[_nghost-%COMP%]   .private-classes-page[_ngcontent-%COMP%]   .PrivateClassesPageIFrame[_ngcontent-%COMP%]{border:0;width:100%;height:100%}"];
export { styles as styles };
//# sourceMappingURL=private-classes-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/private-classes/private-classes-page/private-classes-page.component.scss.shim.ngstyle.js
// module id = 1746
// module chunks = 27 28 29